'use client';

import { useState } from 'react';

const faqs = [
  {
    q: 'Does brain training actually work?',
    a: 'Research shows that regular, targeted cognitive exercise can improve specific mental skills over time, particularly memory, attention, and processing speed. Like physical fitness, consistency matters more than intensity.',
  },
  {
    q: 'How much time do I need each day?',
    a: 'Just 10-15 minutes a day is enough. Spark is designed around short, focused sessions that fit into a real life, not an hour-long commitment.',
  },
  {
    q: 'Is Spark suitable for all ages?',
    a: 'Yes. The games are designed to be accessible from your teens through your 80s. Difficulty adjusts automatically so every age group stays appropriately challenged.',
  },
  {
    q: 'Is it really free?',
    a: 'Spark is free to download and start playing. Some features require a subscription. You\'ll see clearly what\'s included before you commit to anything.',
  },
  {
    q: 'What makes Spark different from other brain game apps?',
    a: 'Spark focuses on variety and daily habit-building. With 30+ games across 6 cognitive domains, plus streak tracking and a weekly brain age score, there\'s always a reason to come back.',
  },
];

function FAQItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      style={{
        background: 'white',
        borderRadius: 16,
        marginBottom: 12,
        overflow: 'hidden',
        border: '1px solid #E5E7EB',
      }}
    >
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 24px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
          gap: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{
            width: 28, height: 28, borderRadius: '50%',
            background: '#EFF6FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2.5" style={{ width: 14, height: 14 }}>
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <span style={{ fontSize: 15, fontWeight: 600, color: '#111827' }}>{q}</span>
        </div>
        <svg
          viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2.5"
          style={{ width: 20, height: 20, flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>
      {open && (
        <div style={{ padding: '0 24px 20px 66px', fontSize: 14, color: '#6B7280', lineHeight: 1.7 }}>
          {a}
        </div>
      )}
    </div>
  );
}

export default function FAQAccordion() {
  return (
    <div>
      {faqs.map((faq) => (
        <FAQItem key={faq.q} q={faq.q} a={faq.a} />
      ))}
    </div>
  );
}
